import { render, staticRenderFns } from "./migrantWorkers.vue?vue&type=template&id=12c0abd2&scoped=true"
import script from "./migrantWorkers.vue?vue&type=script&lang=js"
export * from "./migrantWorkers.vue?vue&type=script&lang=js"
import style0 from "./migrantWorkers.vue?vue&type=style&index=0&id=12c0abd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c0abd2",
  null
  
)

export default component.exports